import { render, staticRenderFns } from "./acceptedOrders.vue?vue&type=template&id=7ca7e16e"
import script from "./acceptedOrders.vue?vue&type=script&lang=js"
export * from "./acceptedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports